/*
 * @Author:
 * @LastEditTime: 2022-05-05 18:48:24
 * @Description:zhouhuan
 */
// 给对象中各个属性重新赋值，可赋空，或者赋值另外一个对象中的相同键名对应的键值
const resetObjectValue = (currentObj, otherObj = {}) => {
  const currentObjKeys = Object.keys(currentObj)
  const otherObjKeys = Object.keys(otherObj)
  if (otherObjKeys.length) {
    currentObjKeys.forEach((curVal) => {
      if (otherObjKeys.includes(curVal)) {
        currentObj[curVal] = otherObj[curVal]
      }
    })
  } else {
    currentObjKeys.forEach((key) => {
      currentObj[key] = ''
    })
  }
  return currentObj
}
export { resetObjectValue }
